const EnrollStudentsAdminFields = [
  {
    name: "student_id",
    label: "Student Name",
    type: "select",
    placeholder: "Select student account",
    options: [],
  },
  {
    name: "course_id",
    label: "Course Title",
    type: "text",
    placeholder: "Course Title",
    value: "title",
  },
];

export default EnrollStudentsAdminFields;
